import { api } from "../AxiosInstance";

// Define service functions for general data related API calls
const TransporterService = {
  getMyTransporters: async () => {
    try {
      const response = await api.get("/fed/transporters");
      return response;
      // return response.data; // Return only the data payload
    } catch (error) {
      console.error("Error fetching transporters:", error);
      throw error; // Re-throw error for global handling if necessary
    }
  },
  getTrucksByTransporterId: async (transporterId: number) => {
    try {
      const response = await api.get(
        `/fed/transporter/trucks?transporterId=${transporterId}`
      );
      return response;
    } catch (error) {
      console.error("Error fetching trucks:", error);
      throw error;
    }
  },
  getAllDrivers: async () => {
    try {
      const response = await api.get("/driver");
      return response;
    } catch (error) {
      console.error("Error fetching drivers:", error);
      throw error;
    }
  },
  updateDriverTruck: async (driverId: number, newTruckNumber: string) => {
    try {
      const response = await api.put("/driver/update-truck", {
        driverId,
        newTruckNumber,
      });
      return response;
    } catch (error) {
      console.error("Error updating driver truck:", error);
      throw error;
    }
  },
};

export default TransporterService;
